/**
 * SearchTerm Component
 */

import './styles.scss';

import { Actions as FarceActions } from 'farce';
import * as React from 'react';
import { connect } from 'react-redux';

import { IQueryStringContext, QueryStringContext } from '../../../../contexts/queryString';
import { getSearchFilters } from '../../../../contexts/queryString/selectors';
import Tag, { TagProps } from '../../../molecules/Tag';
import { BrowsePagePath } from '../../../pages/browse/Browse';

interface IOwnDispatchProps {
  gotoBrowsePage(): void;
}

interface IOwnProps extends
  Omit<TagProps, 'label' | 'onClick' | 'size' | 'wrappedComponent'>,
  Pick<IQueryStringContext, 'addSearchFilter'> {
  isInSearchFilters: boolean;
  name: string;
}

type SearchTermExposedProps = Omit<IOwnProps, 'addSearchFilter' | 'isInSearchFilters'>;

type SearchTermProps = IOwnProps & IOwnDispatchProps;

class SearchTerm extends React.Component<SearchTermProps, {}> {
  static defaultProps: Partial<SearchTermProps> = {
    colorScheme: 'light',
  };

  onClick = () => {
    const {
      addSearchFilter,
      gotoBrowsePage,
      isInSearchFilters,
      name,
      taxonomy,
    } = this.props;

    if (isInSearchFilters) {
      gotoBrowsePage();
    } else {
      addSearchFilter({ name, taxonomy: {id: taxonomy.internal_id!, name: taxonomy.name!} });
    }
  }

  render() {
    const { name, ...tagProps } = this.props;
    return (
      <Tag
        label={name!}
        wrappedComponent="li"
        onClick={this.onClick}
        size="large"
        {...tagProps}
      />
    );
  }
}

const ConnectedSearchTerm = connect<{}, IOwnDispatchProps, IOwnProps, IStoreState>(
  null,
  (dispatch) => ({
    gotoBrowsePage: () => {
      dispatch(FarceActions.push(BrowsePagePath));
    },
  }),
)(SearchTerm);

const SearchTermWithQueryStringContext: React.SFC<SearchTermExposedProps> = (props) => (
  <QueryStringContext.Consumer>
    {(ctx) => (
      <ConnectedSearchTerm
        addSearchFilter={ctx.addSearchFilter}
        isInSearchFilters={getSearchFilters(ctx).some((term) => term.name === props.name)}
        {...props}
      />
    )}
  </QueryStringContext.Consumer>
);

export default SearchTermWithQueryStringContext;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/components/organisms/content/SearchTermsBox/SearchTerm.tsx